import moment from 'moment';
import 'moment/locale/ar';
import 'moment/locale/zh-cn';
import 'moment/locale/en-ca';
import 'moment/locale/fr-ca';
export default moment;
